import { render, staticRenderFns } from "./getApiToken.vue?vue&type=template&id=48640a58&scoped=true&"
import script from "./getApiToken.vue?vue&type=script&lang=js&"
export * from "./getApiToken.vue?vue&type=script&lang=js&"
import style0 from "./getApiToken.vue?vue&type=style&index=0&id=48640a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48640a58",
  null
  
)

export default component.exports